import { render, staticRenderFns } from "./StepsCounter.vue?vue&type=template&id=c0a2af1a"
import script from "./StepsCounter.vue?vue&type=script&lang=js"
export * from "./StepsCounter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports